import React, { useEffect, useState } from "react";
import { Bar, Line } from "react-chartjs-2";
import { Chart, registerables } from "chart.js";
import LineChartIcon from "../../../../../assets/icons/line_chart_icon.svg";
import BarChartIcon from "../../../../../assets/icons/bar_chart_icon.svg";
import LineChartWhite from "../../../../../assets/icons/line_chart_white.svg";
import BarChartClr from "../../../../../assets/icons/bar_chart_color.svg";
import RefresIcon from "../../../../../assets/icons/refresh_icon.svg";
import useMediaQuery from "../../../../../hooks/useMediaQuery";
import { sendPostRequest } from "../../../../../actions/app-actions";
import { connect } from "react-redux";
import { Select } from "antd";
import { getAdminBusinessId } from "../../../../../utils/authHelper";
import DashboardDatePicker from "../DashboardDatePicker";
import moment from "moment";
import Tooltip from "../../../../../components/Tooltip";
import ChartViewToggle from "../ChartViewToggle";

Chart.register(...registerables);

const SalesStatesChart = (props) => {
  const [chartType, setChartType] = useState("bar");
  const [chartData, setChartData] = useState(null);
  const [renderChart, setRenderChart] = useState(false);
  const [data, setData] = useState([]);
  const [filterMonth, setFilterMonth] = useState(new Date());
  const [filterYear, setFilterYear] = useState(new Date());
  const [eventId, setEventId] = useState("");
  const [isDailyView, setIsDailyView] = useState(true);
  const isTablet = useMediaQuery("(min-width: 768px)");

  useEffect(() => {
    loadChartData({ is_month_view: "D" });
  }, []);

  const buildChartData = (rawData, type) => ({
    labels: rawData.map((row) => row.index),
    datasets: [
      {
        label: "Sales",
        data: rawData.map((d) => d.total),
        backgroundColor: "rgba(23, 137, 198, 0.8)",
        borderRadius: 6,
        borderWidth: type === "line" ? 2.5 : 0,
        borderColor: type === "line" ? "#1789C6" : "transparent",
        tension: type === "line" ? 0.4 : 0,
        pointRadius: type === "line" ? (isTablet ? 4 : 2) : 0,
        pointBackgroundColor: "#1789C6",
      },
    ],
  });

  const loadChartData = (requestData = {}) => {
    const { sendPostRequest } = props;
    sendPostRequest({
      url: `/admin/event-daily-sales-chart/${getAdminBusinessId()}`,
      data: requestData,
      onSuccess: function (response) {
        const { data: respData } = response;
        setData(respData.data);
        setChartData(buildChartData(respData.data, chartType));
        setRenderChart(true);
      },
      onError: function (error) {
        console.log("error", error);
      },
    });
  };

  useEffect(() => {
    if (data.length > 0) {
      setChartData(buildChartData(data, chartType));
      setRenderChart(true);
    }
  }, [chartType]);

  const chartOptions = {
    responsive: true,
    maintainAspectRatio: false,
    scales: {
      y: {
        min: 0,
        grid: { color: "rgba(0,0,0,0.04)", drawBorder: false },
        ticks: {
          font: { size: 12 },
          color: "#9a9fa5",
          callback: (value) => "$ " + value,
        },
        border: { display: false },
      },
      x: {
        grid: { display: false },
        ticks: { font: { size: 11 }, color: "#9a9fa5" },
        border: { display: false },
      },
    },
    plugins: {
      legend: { display: false },
      tooltip: {
        backgroundColor: "#1a1d1f",
        titleFont: { size: 12, weight: "600" },
        bodyFont: { size: 12 },
        padding: 10,
        cornerRadius: 8,
        callbacks: {
          label: (ctx) => `Sales: $${ctx.parsed.y}`,
        },
      },
    },
  };

  return (
    <div className="chart-card">
      <div className="chart-card-header">
        <div className="chart-card-title">
          <h3>Daily Sales / Event <Tooltip code="P3F9" /></h3>
          <p>Average daily sales per event</p>
        </div>
        <div className="chart-card-actions">
          <div className="filter-group">
            {isDailyView && (
              <DashboardDatePicker
                mode="month"
                value={filterMonth}
                onChange={(val) => {
                  setFilterMonth(val);
                  loadChartData({
                    event_id: eventId,
                    is_month_view: isDailyView ? "D" : "E",
                    month: val ? moment(val).format("MM") : null,
                    year: val ? moment(val).format("YYYY") : null,
                  });
                }}
              />
            )}
            {!isDailyView && (
              <DashboardDatePicker
                mode="year"
                value={filterYear}
                onChange={(val) => {
                  setFilterYear(val);
                  loadChartData({
                    event_id: eventId,
                    is_month_view: isDailyView ? "D" : "E",
                    month: filterMonth ? moment(filterMonth).format("MM") : null,
                    year: val ? moment(val).format("YYYY") : null,
                  });
                }}
              />
            )}
            <ChartViewToggle
              leftLabel="Daily"
              rightLabel="Monthly"
              isRightActive={!isDailyView}
              onChange={(isMonthly) => {
                setIsDailyView(!isMonthly);
                loadChartData({
                  event_id: eventId,
                  is_month_view: isMonthly ? "E" : "D",
                  month: filterMonth ? moment(filterMonth).format("MM") : null,
                  year: filterYear ? moment(filterYear).format("YYYY") : null,
                });
              }}
            />
            <div className="event-select">
              <Select
                size="large"
                placeholder="Select Event"
                allowClear={true}
                onChange={(value) => {
                  setEventId(value);
                  loadChartData({
                    event_id: value,
                    is_month_view: isDailyView ? "D" : "E",
                    month: filterMonth ? moment(filterMonth).format("MM") : null,
                    year: filterYear ? moment(filterYear).format("YYYY") : null,
                  });
                }}
                style={{ width: 150 }}
                options={props.events}
                value={eventId}
              />
            </div>
          </div>
          <div className="chart-controls">
            <button
              className={`chart-type-btn ${chartType === "line" ? "active" : ""}`}
              onClick={() => setChartType("line")}
            >
              <img src={chartType === "line" ? LineChartWhite : LineChartIcon} alt="Line" />
            </button>
            <button
              className={`chart-type-btn ${chartType === "bar" ? "active" : ""}`}
              onClick={() => setChartType("bar")}
            >
              <img src={chartType === "bar" ? BarChartIcon : BarChartClr} alt="Bar" />
            </button>
            <button
              className="refresh-btn"
              onClick={() => {
                setEventId("");
                setIsDailyView(true);
                setFilterMonth(null);
                setFilterYear(null);
                loadChartData({
                  event_id: "",
                  is_month_view: "D",
                  month: null,
                  year: null,
                });
              }}
            >
              <img src={RefresIcon} alt="Reset" />
            </button>
          </div>
        </div>
      </div>

      <div className="chart-card-body" style={{ height: "280px" }}>
        {renderChart && chartType === "bar" && (
          <Bar data={chartData} options={chartOptions} />
        )}
        {renderChart && chartType === "line" && (
          <Line data={chartData} options={chartOptions} />
        )}
      </div>
    </div>
  );
};

export default connect(null, { sendPostRequest })(SalesStatesChart);
